export const AMMO = [
  // ── Arrows ────────────────────────────────────────────────────────────────
  {
    echo: true,
    name: "Crystal Blessing",
    slot: 'ammo',
    regions: ['Tirannwn'],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 5 },
    },
    effect: {
      type: 'per_equipped_piece',
      pieces: ['Crystal Helm', 'Crystal Body', 'Crystal Legs', 'Crystal Shield'],
      bonusPerPiece: [
        { category: 'attack', stat: 'magic', value: 20 },
        { category: 'other', stat: 'magicDamage', value: 2 },
      ],
      description: "Crystal Blessing: Crystal Armour bonuses for Accuracy and Damage apply to all Melee weapons and Magic powered weapons whilst equipped. Additionally provides +2% magic damage and +20 Magic attack bonus per Crystal Armour piece equipped.",
    },
  },
  // ── Arrows ────────────────────────────────────────────────────────────────
  {
    name: 'Bronze arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 7, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Iron arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 10, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Steel arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 16, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Mithril arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 22, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Adamant arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 31, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Broad arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [{ skill: 'Slayer', level: 55 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 28, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Rune arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 49, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Amethyst arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 55, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon arrow',
    slot: 'ammo',
    ammoType: 'arrows',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 60, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Bolt rack',
    slot: 'ammo',
    ammoType: 'bolt_rack',
    regions: ['Morytania'],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 55, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Bolts ─────────────────────────────────────────────────────────────────
  {
    name: 'Bronze bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 10, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Iron bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 46, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Steel bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 64, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Mithril bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 82, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Adamant bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 100, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Broad bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [{ skill: 'Slayer', level: 55 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 100, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Runite bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 115, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Ruby bolts (e)',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 103, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Diamond bolts (e)',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 105, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragonstone bolts (e)',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 117, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Onyx bolts (e)',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 120, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon bolts',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 122, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon bolts (e)',
    slot: 'ammo',
    ammoType: 'bolts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 117, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Darts ─────────────────────────────────────────────────────────────────
  {
    name: 'Adamant dart',
    slot: 'ammo',
    ammoType: 'darts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 17, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Rune dart',
    slot: 'ammo',
    ammoType: 'darts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 26, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Amethyst dart',
    slot: 'ammo',
    ammoType: 'darts',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 28, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon dart',
    slot: 'ammo',
    ammoType: 'darts',
    regions: ['Tirannwn'],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 35, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Atlatl Darts ──────────────────────────────────────────────────────────
  {
    name: 'Atlatl dart',
    slot: 'ammo',
    ammoType: 'atlatl_darts',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Blazing atlatl dart',
    slot: 'ammo',
    ammoType: 'atlatl_darts',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 40, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Javelins ──────────────────────────────────────────────────────────────
  {
    name: 'Rune javelin',
    slot: 'ammo',
    ammoType: 'javelins',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 124, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Amethyst javelin',
    slot: 'ammo',
    ammoType: 'javelins',
    regions: [],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 135, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon javelin',
    slot: 'ammo',
    ammoType: 'javelins',
    regions: ['Tirannwn'],
    requirements: [],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 150, magicDamage: 0, prayer: 0 },
    },
  }
];
